import { BasePlan } from 'wizards/models/base/base-plan-models';
import { EncryptionAlgorithm } from '../compression-encription-models';
import { DeleteFileSettingsBase } from './base-models/plan-delete-file-settings-model';
import { DiskInfoCommunication } from './base-models/plan-disk-info-model';
import { EncryptionSettings } from './base-models/plan-encryption-settings-model';
import { SyntheticFull } from './base-models/plan-syntetic-full-model';
import { VirtualMachinesFromBackend } from './virtual-machine-from-backend';

export type VirtualMachineExType = { VMName: string; UUID: string; DiskInfo: DiskInfoCommunication[] };

export class BaseVMWarePlanModel extends BasePlan implements EncryptionSettings, DeleteFileSettingsBase, SyntheticFull {
  EncryptionAlgorithm: EncryptionAlgorithm;
  EncryptionKeySize: number;
  IsSyntheticSupported: boolean;
  RetentionDelay: string;
  RetentionDeleteLastVersion: boolean;
  RetentionNumberOfVersions: number;
  RetentionTime: string;
  RetentionUseDefaultSettings: boolean;
  SyntheticFull: boolean;
  UseBackupDate: boolean;
  UseServerSideEncryption: boolean;

  public Host: boolean;
  public Login: boolean;
  public Password: boolean;
  public VirtualMachinesEx: VirtualMachineExType[];
  public VirtualMachines: VirtualMachinesFromBackend[];
  constructor() {
    super();
  }
}
